// Audit Register rule FE-1: FastAPI error `detail` can be a string, an object
// ({code, message, redirect} for 402 paywalls) or an array (422 validation).
// Never pass it raw to toast.error — always extract a human-readable string.
export function getApiErrorMessage(error, fallback = "Something went wrong") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail[0]?.msg || fallback;
  if (detail && typeof detail === "object") return detail.message || fallback;
  return fallback;
}

// True when the backend rejected the call because the user's plan lacks the feature
export function isPlanGateError(error) {
  const detail = error?.response?.data?.detail;
  return (
    error?.response?.status === 402 &&
    (detail?.code === "feature_not_in_plan" || detail?.code === "subscription_required")
  );
}
